import {
  Box,
  Button,
  Flex,
  Image,
  HStack,
  Text,
  useColorMode,
  useColorModeValue,
  IconButton,
  useDisclosure,
  Stack,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon, CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import logo from "../../assets/logo-relax.png";
import { useNavigate } from "react-router-dom";

interface Links {
  title: string;
  link: string;
}

interface Props {
  data: Links;
}

const NavLink = (props: Props) => {
  const navigate = useNavigate();

  const { data } = props;
  return (
    <Box
      as="a"
      px={2}
      py={1}
      style={{ cursor: "pointer" }}
      rounded={"md"}
      _hover={{
        textDecoration: "none",
        bg: useColorModeValue("gray.200", "gray.700"),
      }}
      onClick={() => {
        navigate(data.link);
      }}
    >
      {data.title}
    </Box>
  );
};

export const Navigation = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const Links = [{ title: "Buy $RLAX", link: "/buy" }];
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openPdf = () => {
    window.open("/whitepaper.pdf", "_blank");
  };

  return (
    <>
      <Box
        data-testid="navigation"
        bg={useColorModeValue("gray.100", "gray.900")}
        px={4}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={5} alignItems={"center"}>
            <Box>
              <Image
                className="filter"
                width={10}
                src={logo}
                alt="RelaxAI Platform"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/");
                }}
              />
            </Box>
            <Text
              fontWeight={800}
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/");
              }}
            >
              RelaxAI
            </Text>
            <HStack
              as={"nav"}
              spacing={4}
              display={{ base: "none", md: "flex" }}
            >
              {Links.map((link, index) => (
                <NavLink key={index} data={link}></NavLink>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={"center"}>
            <Button
              variant={"solid"}
              colorScheme="blue"
              size={"sm"}
              mr={4}
              onClick={openPdf}
            >
              Whitepaper
            </Button>
            <Button
              mr={0}
              onClick={toggleColorMode}
              aria-label={"toggleButton"}
              data-testid="toggleButton"
            >
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              {Links.map((link, index) => (
                <NavLink key={index} data={link}></NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
};
